import {FormControl, FormGroup, Validators} from '@angular/forms';
import {translate} from '@ngneat/transloco';

export const kSuiteFormGroupValues = {
  legalEntityType: {
    values: [
      {label: translate('Un particulier'), value: 'individual'},
      {label: translate('Une entreprise'), value: 'company'},
      {label: translate('Une association'), value: 'association'},
      {label: translate('Un organisme public'), value: 'public_body'}
    ]
  },
};

export const kSuiteFormGroup = new FormGroup({
  account: new FormGroup({
    legal_entity_type: new FormControl('individual', [Validators.required, Validators.minLength(2)]),
    name: new FormControl(''),
    vat_number: new FormControl(''),
    street: new FormControl(null, [Validators.required, Validators.minLength(3)]),
    street2: new FormControl(null, []),
    street3: new FormControl(null, []),
    zip: new FormControl(null, [Validators.required, Validators.minLength(2)]),
    city: new FormControl(null, [Validators.required, Validators.minLength(2)]),
    country: new FormControl(null),
    country_id: new FormControl(null, [Validators.required])
  }),
  user: new FormGroup({
    firstname: new FormControl(null, [Validators.required]),
    lastname: new FormControl(null, [Validators.required]),
    reminder_phone: new FormControl(null, [Validators.required]),
    email: new FormControl(null, [Validators.required]),
    password: new FormControl(null, [Validators.required]),
    email_recovery: new FormControl(null, []),
  }, {updateOn: 'change'}),
  cgu_acceptance: new FormControl(false),
  mailing_acceptance: new FormControl(false)
});


export function conditionalValidator(predicate, validator) {
  return (formControl => {
    if (!formControl.parent) {
      return null;
    }
    if (predicate()) {
      return validator(formControl);
    }
    return null;
  });
}
